import { combineReducers } from "redux";
import { LoginReducer } from "views/examples/reducer";

export default combineReducers({ user: LoginReducer });
